// extracted by css-extract-rspack-plugin
var _1 = "checkmark__ZYCvo";
var _2 = "priceBox__e2LEJ";
var _3 = "priceBox__description__vIqqa";
var _4 = "priceBox__features__iuiQb";
var _5 = "priceBox__header__qzV4P";
var _6 = "priceBox__price__ZJafH";
var _7 = "priceBox__quantifier__qXhP8";
export { _1 as "checkmark", _2 as "priceBox", _3 as "priceBox__description", _4 as "priceBox__features", _5 as "priceBox__header", _6 as "priceBox__price", _7 as "priceBox__quantifier" }
export default { "checkmark": _1, "priceBox": _2, "priceBox__description": _3, "priceBox__features": _4, "priceBox__header": _5, "priceBox__price": _6, "priceBox__quantifier": _7 }
